import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import contractorActions from "../../../../_actions/contractorActions";
import { getTradeOptions } from "../../../../_helpers/tradeOptions";
import { getProjContractorOptions } from "../../../../_helpers/contractorOptions";
import laborActions from "../../../../_actions/laborActions";

class EditLaborModal extends Component {
  state = {
    formData: {
      laborId: 0,
      projectId: 0,
      contractorId: 0,
      selectedContractor: null,
      contractor: "",
      firstName: "",
      lastName: "",
      selectedDefaultTrade: null,
      defaultTradeTradeId: 0,
      phone: "",
      loadedRegRate: 0,
      loadedOTRate: 0,
    },
    tradeOptions: [],
    formErrors: {
      selectedContractor: null,
      firstName: null,
      lastName: null,
      selectedDefaultTrade: null,
    },
    formWarnings: {
      selectedContractor: null,
    },
  };

  componentDidMount() {
    const {
      projectId,
      laborDetails: selectedLabor,
      projContractorList,
      isNew,
      tradeList,
    } = this.props;

    const tradeOptions = getTradeOptions(tradeList);
    if (selectedLabor && !isNew) {
      const contractor = (projContractorList || []).find(
        (c) => c.contractorId === selectedLabor.contractorId
      );
      const trade = selectedLabor.defaultTradeTradeId
        ? tradeOptions.find((lt) => lt.value === selectedLabor.defaultTradeTradeId)
        : null;
      this.setState({
        formData: {
          ...this.state.formData,
          projectId,
          laborId: selectedLabor.laborId,
          contractorId: selectedLabor.contractorId,
          selectedContractor: {
            value: contractor.contractorId,
            label: contractor.name,
          },
          firstName: selectedLabor.firstName || "",
          lastName: selectedLabor.lastName || "",
          selectedDefaultTrade: trade, // null if defaultTradeTradeId is not provided
          defaultTradeTradeId: trade ? trade.value : 0,
          phone: selectedLabor.phone || "",
          loadedRegRate: selectedLabor.loadedRegRate || 0,
          loadedOTRate: selectedLabor.loadedOTRate || 0,
        },
        tradeOptions,
      });
    } else this.setState({ tradeOptions });
  }

  handleChange_editLaborForm = (e) => {
    const formData = { ...this.state.formData };
    formData[e.target.name] = e.target.value;
    this.setState({ formData });
  };

  handleChange_editLaborForm_select =
    (fieldName, optionFieldName) => (selectedOption) => {
      const { isNew, laborDetails: selectedLabor } = this.props;
      const formData = { ...this.state.formData };
      formData[fieldName] = selectedOption.value;
      formData[optionFieldName] = selectedOption;

      // When editing the labor data (i.e. when !isNew), warn the user about
      // the consequences of changing the contractor.
      let formWarnings = { ...this.state.formWarnings };
      if (!isNew && fieldName === "contractorId")
        formWarnings.selectedContractor =
          selectedLabor.contractorId !== selectedOption.value
            ? "Changing the contractor will also cause all existing labor entries " +
              "in daily reports to be updated with this new contractor. Proceed with " +
              "this change only if this is a correction. If the laborer moved to a new " +
              "contractor, create a new labor entry."
            : null;
      this.setState({ formData, formWarnings }, () => this.validateForm(fieldName));
    };

  handleChange_editLaborForm_check = (e) => {
    const formData = { ...this.state.formData };
    formData[e.target.name] = e.target.checked;
    this.setState({ formData });
  };

  handleBlur_editLaborForm = (e) => this.validateForm(e.target.name);
  handleBlur_editLaborForm_select = (fieldName) => () => this.validateForm(fieldName);

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "contractorId":
        if (formData.selectedContractor === null)
          formErrors.selectedContractor = "Contractor is required";
        else formErrors.selectedContractor = null;
        break;
      case "firstName":
        if (formData.firstName === "") formErrors.firstName = "First name is required";
        else formErrors.firstName = null;
        break;
      case "lastName":
        if (formData.lastName === "") formErrors.lastName = "Last name is required";
        else formErrors.lastName = null;
        break;
      case "selectedDefaultTrade":
        if (formData.selectedDefaultTrade === null)
          formErrors.selectedDefaultTrade = "Trade is required";
        else formErrors.selectedDefaultTrade = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { selectedContractor, firstName, lastName, selectedDefaultTrade } =
      this.state.formErrors;
    const { formData } = this.state;
    if (
      selectedContractor ||
      firstName ||
      lastName ||
      selectedDefaultTrade ||
      formData.selectedContractor === null ||
      formData.firstName === "" ||
      formData.lastName === "" ||
      formData.selectedDefaultTrade == null
    )
      return true;
    else return false;
  };

  handleSubmit_editLaborForm = (e) => {
    e.preventDefault();
    const { projectId, dispatch, toggleEditLaborModal, isNew, user } = this.props;
    const formData = { ...this.state.formData };
    formData.addedByUserId = isNew ? user.userId : null;
    formData.projectId = projectId;
    if (!this.formIsIncomplete()) {
      if (isNew === false)
        dispatch(laborActions.update(formData)).then(() => {
          // this.resetFormData();
          toggleEditLaborModal();
        });
      if (isNew === true)
        dispatch(laborActions.add(formData)).then(() => {
          // this.resetFormData();
          toggleEditLaborModal();
        });
    }
  };

  resetFormData = () => {
    const formData = {
      projectId: 0,
      selectedContractor: null,
      contractor: "",
      firstName: "",
      lastName: "",
      selectedDefaultTrade: null,
      defaultTradeTradeId: 0,
      loadedRegRate: "",
      loadedOTRate: "",
    };
    this.setState({ formData });
  };

  toggleAlert_errorOnSubmit = () => {
    this.setState({
      showAlert_errorOnSubmit: !this.state.showAlert_errorOnSubmit,
    });
  };

  handleAlert_errorOnSubmit = () => (e) => {
    e && e.preventDefault();
    this.toggleAlert_errorOnSubmit();
  };

  render() {
    const { formData, formErrors, formWarnings, tradeOptions } = this.state;
    const { showEditLaborModal, toggleEditLaborModal, projContractorList, isNew } =
      this.props;
    const closeBtn = (
      <button className="close" onClick={toggleEditLaborModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditLaborModal}
          toggle={toggleEditLaborModal}
          className={this.props.className}
          size={"lg"}
          fade={false}
        >
          <ModalHeader
            toggle={toggleEditLaborModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon={isNew ? "plus" : "edit"} className="fa-fw mr-2" />
            {isNew ? "Add New Labor" : "Edit Labor"}
          </ModalHeader>
          <ModalBody>
            <form
              id="editLaborForm"
              onSubmit={this.handleSubmit_editLaborForm}
              autoComplete={"off"}
            >
              <div className="card mx-2 mt-2 bg-lightgray">
                <div className="card-body">
                  <div className="form-row form-group mb-0">
                    <label className="col-sm-3 col-form-label">
                      <b>Contractor:</b>
                    </label>
                    <div className="col-sm-9 my-auto">
                      <Select
                        name="contractorId"
                        id="contractorId"
                        value={formData.selectedContractor}
                        options={
                          projContractorList &&
                          getProjContractorOptions(projContractorList)
                        }
                        onChange={this.handleChange_editLaborForm_select(
                          "contractorId",
                          "selectedContractor"
                        )}
                        placeholder="(Select a Contractor)"
                        onBlur={this.handleBlur_editLaborForm_select("contractorId")}
                      />
                      {formErrors.selectedContractor && (
                        <span className="error-small">
                          <small>{formErrors.selectedContractor}</small>
                        </span>
                      )}
                      {formWarnings.selectedContractor && (
                        <div className="alert alert-warning p-2 w-100 mb-0 mt-2">
                          <h6>
                            <FontAwesomeIcon
                              icon="exclamation-triangle"
                              className="fa-fw mr-2"
                            />
                            Warning
                          </h6>
                          {formWarnings.selectedContractor}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card m-2">
                <div className="card-body">
                  <div className="form-row form-group mb-2">
                    <label htmlFor="firstName" className="col-sm-3 col-form-label">
                      <b>First Name:</b>*
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="text"
                        name="firstName"
                        id="firstName"
                        className="form-control"
                        maxLength="50"
                        value={formData.firstName}
                        onChange={this.handleChange_editLaborForm}
                        onBlur={this.handleBlur_editLaborForm}
                      />
                      {formErrors.firstName && (
                        <span className="error-small">
                          <small>{formErrors.firstName}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="lastName" className="col-sm-3 col-form-label">
                      <b>Last Name:</b>*
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="text"
                        name="lastName"
                        id="lastName"
                        className="form-control"
                        maxLength="50"
                        value={formData.lastName}
                        onChange={this.handleChange_editLaborForm}
                        onBlur={this.handleBlur_editLaborForm}
                      />
                      {formErrors.lastName && (
                        <span className="error-small">
                          <small>{formErrors.lastName}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="trade" className="col-sm-3 col-form-label">
                      <b>Default Trade:</b>*
                    </label>
                    <div className="col-sm-8">
                      <Select
                        name="trade"
                        id="trade"
                        value={formData.selectedDefaultTrade}
                        options={tradeOptions}
                        onChange={this.handleChange_editLaborForm_select(
                          "defaultTradeTradeId",
                          "selectedDefaultTrade"
                        )}
                        onBlur={this.handleBlur_editLaborForm}
                      />
                      {formErrors.selectedDefaultTrade && (
                        <span className="error-small">
                          <small>{formErrors.selectedDefaultTrade}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="phone" className="col-sm-3 col-form-label">
                      Phone:
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="tel"
                        name="phone"
                        id="phone"
                        className="form-control"
                        value={formData.phone || ""}
                        onChange={this.handleChange_editLaborForm}
                        onBlur={this.handleBlur_editLaborForm}
                      />
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="loadedRegRate" className="col-sm-3 col-form-label">
                      Loaded Reg. Rate:
                    </label>
                    <div className="col-sm-4 mr-1">
                      <input
                        type="number"
                        name="loadedRegRate"
                        id="loadedRegRate"
                        className="form-control"
                        value={formData.loadedRegRate}
                        onChange={this.handleChange_editLaborForm}
                        onBlur={this.handleBlur_editLaborForm}
                      />
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="loadedOTRate" className="col-sm-3 col-form-label">
                      Loaded OT Rate:
                    </label>
                    <div className="col-sm-4 mr-1">
                      <input
                        type="number"
                        name="loadedOTRate"
                        id="loadedOTRate"
                        className="form-control"
                        value={formData.loadedOTRate}
                        onChange={this.handleChange_editLaborForm}
                        onBlur={this.handleBlur_editLaborForm}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group mb-0">
              <input
                className="btn btn-primary"
                name="addNewLaborButton"
                type="submit"
                form="addNewLabor"
                onClick={this.handleSubmit_editLaborForm}
                value={isNew ? "Add" : "Save"}
                disabled={this.formIsIncomplete()}
              />{" "}
              <button
                className="btn btn-secondary ml-2"
                color="secondary"
                onClick={toggleEditLaborModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
  // This modal is only accessible after laborDetails is fully loaded, since
  // the "Edit..." button is disabled until fetching is complete.
  laborDetails: state.labors.openLaborDetails[ownProps.projectId]
    ? state.labors.openLaborDetails[ownProps.projectId][ownProps.laborId] || null
    : null,
  tradeList: state.feederLists.tradeList,
});

export default connect(mapStateToProps)(EditLaborModal);
